import firebase from '../config/firebase';

export const USER = 'user';

export const USER_ACTION_TYPES = {
  RECEIVE_AUTH_SETUP: `${USER}/RECEIVE_AUTH_SETUP`,
  SETUP_AUTH: `${USER}/SETUP_AUTH`,
  REGISTER_USER: `${USER}/FETCH_USER`,
  FETCH_USER: `${USER}/FETCH_USER`,
  RECEIVE_USER: `${USER}/RECEIVE_USER`,
  REGISTER_TEMP_USER: `${USER}/REGISTER_TEMP_USER`,
  RECEIVE_TEMP_USER: `${USER}/RECEIVE_TEMP_USER`,
  AUTH_STATE_CHANGE: `${USER}/AUTH_STATE_CHANGE`,
  FETCH_LOGOUT: `${USER}/FETCH_LOGOUT`,
  RECEIVE_LOGOUT: `${USER}/RECEIVE_LOGOUT`,
  SET_AVATAR: `${USER}/SET_AVATAR`,
  RECEIVE_INCORRECT_PASSWORD: `${USER}/RECEIVE_INCORRECT_PASSWORD`,
  CLEAR_INCORRECT_PASSWORD: `${USER}/CLEAR_INCORRECT_PASSWORD`,
  RECEIVE_UNAVAILABLE_EMAIL: `${USER}/RECEIVE_UNAVAILABLE_EMAIL`,
  CLEAR_UNAVAILABLE_EMAIL: `${USER}/CLEAR_UNAVAILABLE_EMAIL`,
  TOGGLE_NOTIFICATIONS: `${USER}/TOGGLE_NOTIFICATIONS`,
  UPDATE_USER: `${USER}/UPDATE_USER`,
  RECEIVE_UPDATED_USER: `${USER}/RECEIVE_UPDATED_USER`,
  RECEIVE_TOGGLED_NOTIFICATIONS: `${USER}/RECEIVE_TOGGLED_NOTIFICATIONS`,
  RECEIVE_USER_BY_ID: `${USER}/RECEIVE_USER_BY_ID`,
  FETCH_USER_BY_ID: `${USER}/FETCH_USER_BY_ID`,
  RECEIVE_TOUCH_ID_NOT_SUPPORTED: `${USER}/RECEIVE_TOUCH_ID_NOT_SUPPORTED`,
  RECEIVE_CLEAR_TOUCH_ID_NOT_SUPPORTED: `${USER}/RECEIVE_CLEAR_TOUCH_ID_NOT_SUPPORTED`,
  RECEIVE_INCORRECT_TOUCH_ID: `${USER}/RECEIVE_INCORRECT_TOUCH_ID`,
  RECEIVE_TOUCH_ID_CANCELLED: `${USER}/RECEIVE_TOUCH_ID_CANCELLED`,
  RESET_PASSWORD: `${USER}/RESET_PASSWORD`,
  RECEIVE_RESET_PASSWORD: `${USER}/RECEIVE_RESET_PASSWORD`,
  RECEIVE_INVALID_EMAIL: `${USER}/RECEIVE_INVALID_EMAIL`,
  CLEAR_INVALID_EMAIL: `${USER}/CLEAR_INVALID_EMAIL`,
  RECEIVE_WEAK_PASSWORD: `${USER}/RECEIVE_WEAK_PASSWORD`,
  CLEAR_WEAK_PASSWORD: `${USER}/CLEAR_WEAK_PASSWORD`,
  CREATE_CUSTOMER: `${USER}/CREATE_CUSTOMER`,
  RECEIVE_CUSTOMER: `${USER}/RECEIVE_CUSTOMER`,
  CREATE_SUBSCRIPTION: `${USER}/CREATE_SUBSCRIPTION`,
  RECEIVE_SUBSCRIPTION: `${USER}/RECEIVE_SUBSCRIPTION`,
  UPDATE_SUBSCRIPTION: `${USER}/UPDATE_SUBSCRIPTION`,
  RECEIVE_UPDATED_SUBSCRIPTION: `${USER}/RECEIVE_UPDATED_SUBSCRIPTION`,
  ADD_PAYMENT_SOURCE: `${USER}/ADD_PAYMENT_SOURCE`,
  RECEIVE_PAYMENT_SOURCE: `${USER}/RECEIVE_PAYMENT_SOURCE`,
  CANCEL_SUBSCRIPTION: `${USER}/CANCEL_SUBSCRIPTION`,
  UPDATE_CUSTOMER: `${USER}/UPDATE_CUSTOMER`,
  RECEIVE_UPDATED_CUSTOMER: `${USER}/RECEIVE_UPDATED_CUSTOMER`,
  FETCH_COUPON: `${USER}/FETCH_COUPON`,
  RECEIVE_INCORRECT_COUPON: `${USER}/RECEIVE_INCORRECT_COUPON`,
  RECEIVE_COUPON: `${USER}/RECEIVE_COUPON`
};

const functionURL = firebase.options_.functionURL

export const CREATE_STRIPE_CUSTOMER_URL = functionURL + '/createStripeCustomer';
export const UPDATE_CUSTOMER_URL = functionURL + '/updateCustomer';
export const CREATE_STRIPE_CUSTOMER_SUBSCRIPTION_URL = functionURL + '/createSubscription';
//TODO need one for purchase, not subscription
export const UPDATE_STRIPE_CUSTOMER_SUBSCRIPTION_URL = functionURL + '/updateSubscription';
export const CANCEL_SUBSCRIPTION_URL = functionURL + '/cancelSubscription';
export const ADD_PAYMENT_SOURCE_URL = functionURL + '/addPaymentSource';
export const FETCH_COUPON = functionURL + '/fetchCoupon';



// WEBPACK FOOTER //
// ./src/redux/user/constants.js